import _extends from "@babel/runtime/helpers/extends";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
var _excluded = ["label", "tooltip", "disabled", "required", "getLabelProps", "innerRef", "children", "error", "maxWidth", "zIndex", "hint"];
import React from 'react';
import { RequiredLabel } from '../Label/Label';
import { Hint } from '../TextInput/Hint';
import { Tooltip } from '../Tooltip';
import { StyledDownshiftAutocomplete, StyledDownshiftField } from './DownshiftField.styled';
import { StyledFieldLabel } from './Field.styled';
import { FieldError } from './FieldError';
export function DownshiftField(props) {
  var label = props.label,
    tooltip = props.tooltip,
    disabled = props.disabled,
    required = props.required,
    getLabelProps = props.getLabelProps,
    innerRef = props.innerRef,
    children = props.children,
    error = props.error,
    maxWidth = props.maxWidth,
    zIndex = props.zIndex,
    hint = props.hint,
    divProps = _objectWithoutProperties(props, _excluded);
  return /*#__PURE__*/React.createElement(StyledDownshiftField, _extends({}, divProps, {
    hasLabel: !!label,
    disabled: disabled,
    ref: innerRef,
    style: {
      zIndex: zIndex,
      position: 'relative'
    }
  }), label && /*#__PURE__*/React.createElement(StyledFieldLabel, getLabelProps(), label, required && /*#__PURE__*/React.createElement(RequiredLabel, null), tooltip && /*#__PURE__*/React.createElement(Tooltip, null, tooltip)), /*#__PURE__*/React.createElement(StyledDownshiftAutocomplete, {
    style: {
      maxWidth: maxWidth
    }
  }, children, /*#__PURE__*/React.createElement(FieldError, {
    error: error,
    htmlFor: props.id
  }), /*#__PURE__*/React.createElement(Hint, {
    hint: hint
  })));
}